module.exports = __webpack_public_path__ + "media/images/portfolio_build-8f113205e1f76f6ffc3d344ea18de626.svg";